var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.localItems),function(item){return _c(_vm.getInfoFieldComponent(item.name),{key:item.name,tag:"component",attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }